import { withAITracking } from '@microsoft/applicationinsights-react-js';
import React, { Component, Fragment } from 'react';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ai } from './TelemetryService';

// A hooks-based replacement for the react router v5 withRouter HOC
// AppInsights needs this in order to watch the browser history and track page changes.
// Copied from https://stackoverflow.com/a/71097818/1453907
function withRouter(Component: any) {
    function ComponentWithRouterProp(props: any) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        return (
            <Component
                {...props}
                router={{ location, navigate, params }}
            />
        );
    }

    return ComponentWithRouterProp;
}


// P
// Copied from https://github.com/Azure-Samples/application-insights-react-demo/blob/master/src/telemetry-provider.jsx
interface ITelemetryProviderProps {
    instrumentationKey: string,
    router: any
}
/**
 * This Component provides telemetry with Azure App Insights
 *
 * NOTE: the package '@microsoft/applicationinsights-react-js' has a HOC withAITracking that requires this to be a Class Component rather than a Functional Component
 * Copied from
 */
class TelemetryProvider extends Component<React.PropsWithChildren<ITelemetryProviderProps>> {
    override state = {
        initialized: false
    };

    override componentDidMount() {
        if (!this.state.initialized) {
            ai.initialize(this.props.instrumentationKey, this.props.router);
            this.setState({ initialized: true });
        }
    }

    override render() {
        this.props.router
        return (
            <Fragment>
                {this.props.children}
            </Fragment>
        );
    }
}


export default withRouter(withAITracking(ai.reactPlugin, TelemetryProvider));
